var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import services from '../../services';
import { DevPlanMethod } from '../../store/signup/models';
import { checkOrgStatusSummery } from '../orgStatusSummery/actions';
var DeveloperPlansService = services.DeveloperPlansService, BundleService = services.BundleService, OrganizationService = services.OrganizationService;
export var listDeveloperPlansOrg = function (orgId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var developerPlans, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'LOAD_ORG_DEVELOPER_PLAN_REQUEST' });
                return [4 /*yield*/, DeveloperPlansService.listDeveloperPlansOrg(orgId)];
            case 1:
                developerPlans = (_a.sent()).objects;
                dispatch({
                    type: 'LOAD_ORG_DEVELOPER_PLAN_SUCCESS',
                    developerPlans: developerPlans,
                    developerPlansOrg: orgId,
                });
                return [3 /*break*/, 3];
            case 2:
                err_1 = _a.sent();
                dispatch({ type: 'LOAD_ORG_DEVELOPER_PLAN_FAILURE', err: err_1 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
export var changeInterval = function (interval) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        try {
            dispatch({
                type: 'CHANGE_ORG_DEVELOPER_PLAN_INTERVAL_REQUEST',
                interval: DevPlanMethod.Annually,
            });
            dispatch({
                type: 'CHANGE_ORG_DEVELOPER_PLAN_INTERVAL_SUCCESS',
                interval: interval,
            });
        }
        catch (err) {
            dispatch({
                type: 'CHANGE_ORG_DEVELOPER_PLAN_INTERVAL_FAILURE',
                interval: DevPlanMethod.Annually,
            });
        }
        return [2 /*return*/, null];
    });
}); }; };
export var addBundlesToDevPlanOrg = function (orgId, bundles) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'PURCHASE_DEV_PLAN_BUNDLES_REQUEST' });
                return [4 /*yield*/, BundleService.addBundlesToDevPlanOrg(orgId, bundles)];
            case 1:
                _a.sent();
                dispatch({ type: 'PURCHASE_DEV_PLAN_BUNDLES_SUCCESS' });
                return [2 /*return*/, true];
            case 2:
                err_2 = _a.sent();
                dispatch({ type: 'PURCHASE_DEV_PLAN_BUNDLES_FAILURE' });
                return [2 /*return*/, false];
            case 3: return [2 /*return*/, true];
        }
    });
}); }; };
export var removeBundlesFromDevPlanOrg = function (orgId, bundles) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'PURCHASE_DEV_PLAN_BUNDLES_REQUEST' });
                return [4 /*yield*/, BundleService.removeBundlesFromDevPlanOrg(orgId, bundles)];
            case 1:
                _a.sent();
                dispatch({ type: 'PURCHASE_DEV_PLAN_BUNDLES_SUCCESS' });
                return [2 /*return*/, true];
            case 2:
                err_3 = _a.sent();
                dispatch({ type: 'PURCHASE_DEV_PLAN_BUNDLES_FAILURE' });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, false];
        }
    });
}); }; };
export var purchaseDeveloperPlansOrg = function (orgId, devPlanId, bundle) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var purchasedDeveloperPlan, err_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'PURCHASE_ORG_DEVELOPER_PLAN_REQUEST' });
                return [4 /*yield*/, DeveloperPlansService.purchaseDeveloperPlansOrg(orgId, devPlanId, bundle)];
            case 1:
                purchasedDeveloperPlan = (_a.sent()).object;
                if (purchasedDeveloperPlan) {
                    dispatch({
                        type: 'PURCHASE_ORG_DEVELOPER_PLAN_SUCCESS',
                        purchasedDeveloperPlan: purchasedDeveloperPlan,
                    });
                    dispatch(checkOrgStatusSummery(orgId));
                    dispatch(listDeveloperPlansOrg(orgId));
                }
                return [2 /*return*/, true];
            case 2:
                err_4 = _a.sent();
                dispatch({ type: 'PURCHASE_ORG_DEVELOPER_PLAN_FAILURE', err: err_4 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
export var listBundlesPurchasableByOrg = function (orgId, DevPlanID) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var bundles, err_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'LOAD_BUNDLES_REQUEST' });
                return [4 /*yield*/, BundleService.listBundlesAvailableByOrg(orgId, DevPlanID)];
            case 1:
                bundles = (_a.sent()).objects;
                dispatch({ type: 'LOAD_BUNDLES_SUCCESS', bundles: bundles, bundlesOrg: orgId });
                return [3 /*break*/, 3];
            case 2:
                err_5 = _a.sent();
                dispatch({ type: 'LOAD_BUNDLES_FAILURE', err: err_5 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
export var getActiveBundles = function (orgId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var ActiveBundles, err_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'LOAD_ACTIVE_BUNDLES_REQUEST' });
                return [4 /*yield*/, BundleService.listActiveOrgBundles(orgId)];
            case 1:
                ActiveBundles = _a.sent();
                dispatch({
                    type: 'LOAD_ACTIVE_BUNDLES_SUCCESS',
                    ActiveBundles: ActiveBundles.objects,
                    activeBundlesOrg: orgId,
                });
                return [3 /*break*/, 3];
            case 2:
                err_6 = _a.sent();
                dispatch({ type: 'LOAD_ACTIVE_BUNDLES_FAILURE', err: err_6 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
export var updateActiveBundles = function (selectedBundles) {
    return function (dispatch) {
        dispatch({
            type: 'UPDATE_ACTIVE_BUNDLES_SUCCESS',
            selectedBundles: selectedBundles,
        });
    };
};
export var updateUpdatedAddons = function (selectedBundles) {
    return function (dispatch) {
        dispatch({
            type: 'UPDATE_UPDATED_ADDONS_SUCCESS',
            selectedBundles: selectedBundles,
        });
    };
};
export var cancelDevPlan = function (orgId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'CANCEL_DEV_PLAN_REQUEST' });
                return [4 /*yield*/, DeveloperPlansService.cancelDevPlan(orgId)];
            case 1:
                _a.sent();
                dispatch({ type: 'CANCEL_DEV_PLAN_SUCCESS' });
                dispatch(checkOrgStatusSummery(orgId));
                return [3 /*break*/, 3];
            case 2:
                err_7 = _a.sent();
                dispatch({ type: 'CANCEL_DEV_PLAN_FAILURE', err: err_7 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
export var reactivateDevPlanStatus = function (orgId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'REACTIVATE_DEV_PLAN_REQUEST' });
                return [4 /*yield*/, DeveloperPlansService.reactivateDevPlan(orgId)];
            case 1:
                _a.sent();
                dispatch({ type: 'REACTIVATE_DEV_PLAN_SUCCESS' });
                dispatch(checkOrgStatusSummery(orgId));
                return [3 /*break*/, 3];
            case 2:
                err_8 = _a.sent();
                dispatch({ type: 'REACTIVATE_DEV_PLAN_FAILURE', err: err_8 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
export var getAllConsumedDeveloperPlan = function (orgId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var devPlanConsume, err_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'GET_DEV_PLAN_CONSUMED_REQUEST' });
                return [4 /*yield*/, BundleService.getConsumedDeveloperPlan(orgId)];
            case 1:
                devPlanConsume = (_a.sent()).object;
                dispatch({
                    type: 'GET_DEV_PLAN_CONSUMED_SUCCESS',
                    devPlanConsume: devPlanConsume,
                    devPlanConsumeOrg: orgId,
                });
                return [3 /*break*/, 3];
            case 2:
                err_9 = _a.sent();
                dispatch({ type: 'GET_DEV_PLAN_CONSUMED_FAILURE', err: err_9 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
export var getDevPlanInvoiceDetails = function (orgId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var devPlanInvoiceDetails, err_10;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, DeveloperPlansService.getDevPlanInvloiceDetails(orgId)];
            case 1:
                devPlanInvoiceDetails = (_a.sent()).object;
                dispatch({
                    type: 'DEV_PLAN_INVOICE_DETAILS_SUCCESS',
                    devPlanInvoiceDetails: devPlanInvoiceDetails,
                    orgId: orgId,
                });
                return [3 /*break*/, 3];
            case 2:
                err_10 = _a.sent();
                dispatch({ type: 'DEV_PLAN_INVOICE_DETAILS_FAILURE' });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
export var getProRatedAmount = function (orgId, devPlanId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var proRatedAmount, err_11;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'GET_PRORATED_AMOUNT_REQUEST' });
                return [4 /*yield*/, DeveloperPlansService.getProRatedAmount(orgId, devPlanId)];
            case 1:
                proRatedAmount = (_a.sent()).object;
                dispatch({
                    type: 'GET_PRORATED_AMOUNT_SUCCESS',
                    details: proRatedAmount,
                    orgId: orgId,
                    devPlanId: devPlanId,
                });
                return [3 /*break*/, 3];
            case 2:
                err_11 = _a.sent();
                dispatch({
                    type: 'GET_PRORATED_AMOUNT_FAILURE',
                });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var getProratedAmountForAddons = function (organizationId, bundles) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var amount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, OrganizationService.getProratedAmountForAddons(organizationId, bundles)];
                case 1:
                    amount = _a.sent();
                    dispatch({
                        type: 'GET_PRO_RATED_AMOUNT_FOR_ADDONS_SUCCESS',
                        proratedAmountForAddons: amount,
                    });
                    return [2 /*return*/];
            }
        });
    }); };
};
export var getResellerDetailsForManagedOrg = function (organizationId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var resellerDetails;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, OrganizationService.getResellerDetailsForManagedOrg(organizationId)];
                case 1:
                    resellerDetails = (_a.sent()).object;
                    dispatch({
                        type: 'GET_RESELLER_DETAILS_FOR_MANAGED_ORG_SUCCESS',
                        resellerDetails: resellerDetails,
                        resellerDetailsOrg: organizationId,
                    });
                    return [2 /*return*/];
            }
        });
    }); };
};
